import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/content";

export default function ContactPreview() {
  return (
    <section className="max-w-site mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="bg-primary-900 rounded-xl px-6 md:px-14 py-12 md:py-16 flex flex-col lg:flex-row items-center justify-between gap-8 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.1]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 15% 30%, oklch(var(--accent-500)) 0, transparent 45%)",
          }}
        ></div>
        <div className="relative max-w-xl text-center lg:text-left">
          <h3 className="text-xl md:text-2xl font-heading font-semibold text-background-50">
            想进一步了解白峰美羽？
          </h3>
          <p className="mt-3 text-sm md:text-base text-primary-200 leading-relaxed">
            无论是产品咨询、合作洽谈，还是想亲自到体验空间感受材质，我们都欢迎与您交流。
          </p>
          <div className="mt-4 flex flex-col sm:flex-row gap-x-6 gap-y-2 text-sm text-primary-100 justify-center lg:justify-start">
            <span className="flex items-center gap-2 justify-center lg:justify-start">
              <i className="ri-phone-line text-accent-400"></i>
              {siteInfo.phone}
            </span>
            <span className="flex items-center gap-2 justify-center lg:justify-start">
              <i className="ri-mail-line text-accent-400"></i>
              {siteInfo.email}
            </span>
          </div>
        </div>
        <Link
          to="/contact"
          className="relative inline-flex items-center px-7 py-3 rounded-md bg-accent-500 text-accent-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer shrink-0"
        >
          联系我们
          <i className="ri-arrow-right-line ml-2"></i>
        </Link>
      </div>
    </section>
  );
}